module.exports = __webpack_public_path__ + "static/media/(H)_MG_5294_-_Pro-Natura_-_Moda_Feminina_-_Moda_Feminina_Infantil.8c9ec14f.jpg";